import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItem, FormLabel, FormInputDate, getDatePickerDate } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';
import { getLocalStandardDate } from '@tesla/design-system';
import { isValidDate } from './utils/isValidDate.js';

var _excluded = ["label", "feedback", "helper", "caption", "tooltip", "placeholder", "formatDate", "dateType"];

/**
 * Renders a date input
 *
 */
function DateInput(props) {
  var _useField = useField(props),
    fieldApi = _useField.fieldApi,
    fieldState = _useField.fieldState,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    userPlaceholder = userProps.placeholder,
    formatDate = userProps.formatDate,
    dateType = userProps.dateType,
    inputProps = _objectWithoutProperties(userProps, _excluded);
  var disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    locale = inputProps.locale;
  var id = userProps.id;
  var showError = fieldState.showError,
    error = fieldState.error,
    value = fieldState.value;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var dateFormatter = formatDate ? formatDate : function (value) {
    return getLocalStandardDate(getDatePickerDate(value, dateType), locale);
  };
  var placeholder = userPlaceholder !== null && userPlaceholder !== void 0 ? userPlaceholder : dateFormatter(dateType === 'string' ? new Date().toISOString().slice(0, 10) : new Date());
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "date",
    disabled: disabled
  }, label ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, label) : null, /*#__PURE__*/React.createElement(FormInputDate, _extends({
    disabled: disabled,
    onBlur: function onBlur() {
      setTouched(true);
    },
    onChange: function onChange() {},
    onDateChange: function onDateChange(v) {
      setValue(v);
    },
    date: value,
    value: dateType == 'string' && value || isValidDate(value) ? dateFormatter(value) : ''
  }, inputProps, {
    placeholder: placeholder,
    id: id,
    inputRef: ref,
    readOnly: readonly,
    dateType: dateType
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError
  })));
}

export { DateInput };
